import { render } from "./RichMenuAssetModal.vue?vue&type=template&id=3e2a5a34&scoped=true"
import script from "./RichMenuAssetModal.vue?vue&type=script&lang=ts"
export * from "./RichMenuAssetModal.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-3e2a5a34"

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QToolbarTitle from 'quasar/src/components/toolbar/QToolbarTitle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QToolbar,QToolbarTitle,QBtn,QCardSection,QForm,QInput,QSeparator,QImg,QFile,QSpace});
